module.exports = __webpack_public_path__ + "3da04ff6c85f7eb9fd5915c6e47cff25.fbx";